export const styles = {
    content: {
       position: 'relative',
       justifyContent: 'center',
    },
    pillButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        backgroundColor: '#0D1B2A',
        borderRadius: 50,
        paddingBlock: 8,
        paddingInline: 20,
        cursor: 'pointer',
    },
    pillText: {
        color: '#FFFFFF',
        fontWeight: 'bold',
        fontSize: 18,
        letterSpacing: 1,
        margin: 0,
    },
    pillIcon: {
        width: 36,
        height: 36,
        borderRadius: '50%',
        objectFit: 'cover',
    },
    dropdown: {
        position: 'absolute',
        right: 0,
        top: '110%',
        width: 190,
        backgroundColor: '#0D1B2A',
        padding: 6,
        borderRadius: 16,
        zIndex: 999,
    }, 
    dropdownItem: {
        display: 'flex',
        padding: 10,
        alignItems: 'center',
        gap: 10,
        cursor: 'pointer',
        borderRadius: 10,
    },
    iconsSmall: {
        width: 24,
        height: 24,
        borderRadius: '50%',
        objectFit: 'cover',
    },
    text: {
        color: '#FFFFFF',
        fontSize: 16,
        fontWeight: '600',
        margin: 0,
    }
};
